import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RTextAreaProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    minRows?: number;
    resize?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

export function RTextArea({ value, onChange, placeholder, disabled, fullWidth, minRows = 4, resize = true, onKeyDown }: RTextAreaProps) {
    return (
        <StyledTextArea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            disabled={disabled}
            fullWidth={fullWidth}
            rows={minRows}
            style={resize ? undefined : { resize: 'none' }}
        />
    );
}

const StyledTextArea = styled('textarea')<{ fullWidth?: boolean }>(({ fullWidth }) => ({
    width: fullWidth ? '100%' : 'auto',
    padding: '10px 14px',
    fontSize: 14,
    color: Colors.darkNavy,
    backgroundColor: Colors.faintGrey,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    outline: 'none',
    boxSizing: 'border-box',
    resize: 'vertical',
    lineHeight: 1.5,
    '&:focus': {
        borderColor: Colors.mediumGrey,
    },
    '&:disabled': {
        backgroundColor: Colors.lightGrey,
        color: Colors.mediumGrey,
    },
    '&::placeholder': {
        color: Colors.disabledGrey,
    },
}));
